module.exports = __webpack_public_path__ + "media/assets/images/account/desktop-banner-5c7c3ab245479b357df8225a433f4056.png";